import { createSelector } from 'reselect';
import { externalHostSelector } from '../ConsumerArea/ConsumerAreaSelector';
import { EXTERNAL_HOST } from '../ConsumerArea/ConsumerAreaConstants';

const upsertAccountModalState = state => state.UpsertAccountModal;

export const currentViewSelector = createSelector(
  upsertAccountModalState,
  ({ currentView }) => currentView,
);

export const focusedAccountSelector = createSelector(
  upsertAccountModalState,
  ({ focusedAccount }) => focusedAccount,
);

export const visibleAccountTypesStackSelector = createSelector(
  upsertAccountModalState,
  ({ visibleAccountTypesStack }) => visibleAccountTypesStack,
);

export const errorsSelector = createSelector(upsertAccountModalState, ({ errors }) => errors);

export const isSavingAccountSelector = createSelector(
  upsertAccountModalState,
  ({ isSavingAccount }) => isSavingAccount,
);

export const isDeletingAccountSelector = createSelector(
  upsertAccountModalState,
  ({ isDeletingAccount }) => isDeletingAccount,
);

export const defaultPrincipalOwnerSelector = createSelector(
  upsertAccountModalState,
  ({ defaultPrincipalOwner }) => defaultPrincipalOwner,
);

export const accountTypesDictionarySelector = createSelector(
  upsertAccountModalState,
  ({ accountTypesDictionary }) => accountTypesDictionary,
);

export const otherAssetTypesDictionarySelector = createSelector(
  upsertAccountModalState,
  ({ otherAssetTypesDictionary }) => otherAssetTypesDictionary,
);

export const isFocusedAccountNewSelector = createSelector(
  upsertAccountModalState,
  ({ isFocusedAccountNew }) => isFocusedAccountNew,
);

export const isFocusedAccountEditableSelector = createSelector(
  upsertAccountModalState,
  externalHostSelector,
  ({ isFocusedAccountEditable }, externalHost) =>
    isFocusedAccountEditable && externalHost !== EXTERNAL_HOST.FTCI,
);

export const isConfirmationModalOpenSelector = createSelector(
  upsertAccountModalState,
  ({ isConfirmationModalOpen }) => isConfirmationModalOpen,
);

export const redirectUrlSelector = createSelector(
  upsertAccountModalState,
  ({ redirectUrl }) => redirectUrl,
);
